import { UserIdentifierType } from '@fuul/sdk';
import Image from 'next/image';
import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, EXPONENT_VENUE_LABELS, ExponentVenue, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const ExponentTriggerDetails = ({ trigger, triggerType }: Props) => {
  const vaultAddress = useMemo(() => trigger.context?.vault_address ?? '', [trigger.context]);

  const venueLabel = useMemo(() => {
    const venue = trigger.context?.venue;
    if (!venue) return '';
    return EXPONENT_VENUE_LABELS[venue as ExponentVenue] ?? venue;
  }, [trigger.context]);

  const scannerUrl = useMemo(() => {
    if (!vaultAddress) return '';
    return `https://explorer.solana.com/address/${vaultAddress}`;
  }, [vaultAddress]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Vault"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/webp/solana.webp" width={12} height={12} alt="Solana" />
            <span>{maskAddressValue(vaultAddress, UserIdentifierType.SolanaAddress)}</span>
          </div>
        }
        href={scannerUrl}
      />

      <TriggerValueDetail label="Venue" value={venueLabel} />
    </div>
  );
};
